export const contentOutlines = {
  shadow: 'shadow',
  border: 'border',
  none: 'none',
};

export const skins = {
  neutral: 'neutral',
  gradient: 'gradient',
  custom: 'custom',
};

export const dataHooks = {
  contentArea: 'preview-widget-content-area',
};
